"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_ex3acj5mf = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/RepositoryMenu.js";
  var hash = "2c4c1ba70ceb927b599b3e45b963372cf3fa2695";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/RepositoryMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "1": {
        start: {
          line: 19,
          column: 28
        },
        end: {
          line: 19,
          column: 43
        }
      },
      "2": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 41
        }
      },
      "3": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 22
        }
      },
      "4": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "5": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 19
        }
      },
      "6": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "7": {
        start: {
          line: 40,
          column: 28
        },
        end: {
          line: 40,
          column: 75
        }
      },
      "8": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "9": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "10": {
        start: {
          line: 59,
          column: 23
        },
        end: {
          line: 59,
          column: 28
        }
      },
      "11": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 69,
          column: 3
        }
      },
      "12": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 68,
          column: 6
        }
      },
      "13": {
        start: {
          line: 63,
          column: 74
        },
        end: {
          line: 63,
          column: 89
        }
      },
      "14": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 76,
          column: 4
        }
      },
      "15": {
        start: {
          line: 79,
          column: 0
        },
        end: {
          line: 80,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "RepositoryMenu",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 23
          }
        },
        loc: {
          start: {
            line: 17,
            column: 26
          },
          end: {
            line: 77,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 33
          },
          end: {
            line: 33,
            column: 34
          }
        },
        loc: {
          start: {
            line: 33,
            column: 39
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 63,
            column: 68
          },
          end: {
            line: 63,
            column: 69
          }
        },
        loc: {
          start: {
            line: 63,
            column: 74
          },
          end: {
            line: 63,
            column: 89
          }
        },
        line: 63
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 6
          },
          end: {
            line: 24,
            column: 35
          }
        }, {
          start: {
            line: 24,
            column: 39
          },
          end: {
            line: 24,
            column: 41
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 31,
            column: 16
          }
        }, {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 22
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }, {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }],
        line: 39
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 10
          }
        }, {
          start: {
            line: 39,
            column: 14
          },
          end: {
            line: 39,
            column: 19
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 40,
            column: 41
          },
          end: {
            line: 40,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 41
          },
          end: {
            line: 40,
            column: 51
          }
        }, {
          start: {
            line: 40,
            column: 55
          },
          end: {
            line: 40,
            column: 71
          }
        }],
        line: 40
      },
      "5": {
        loc: {
          start: {
            line: 47,
            column: 18
          },
          end: {
            line: 47,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 18
          },
          end: {
            line: 47,
            column: 25
          }
        }, {
          start: {
            line: 47,
            column: 29
          },
          end: {
            line: 47,
            column: 42
          }
        }],
        line: 47
      },
      "6": {
        loc: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        }, {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 69,
            column: 3
          }
        }],
        line: 61
      },
      "7": {
        loc: {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 61,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 61,
            column: 11
          }
        }, {
          start: {
            line: 61,
            column: 15
          },
          end: {
            line: 61,
            column: 25
          }
        }],
        line: 61
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "2c4c1ba70ceb927b599b3e45b963372cf3fa2695"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _useStyles = require("./useStyles");

var _ = require("..");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function RepositoryMenu() {
  cov_ex3acj5mf.f[0]++;
  var classes = (cov_ex3acj5mf.s[0]++, (0, _useStyles.useStyles)());

  var _ref = (cov_ex3acj5mf.s[1]++, (0, _react.useState)(false)),
      _ref2 = _slicedToArray(_ref, 2),
      modal = _ref2[0],
      setModal = _ref2[1];

  var _ref3 = (cov_ex3acj5mf.s[2]++, (cov_ex3acj5mf.b[0][0]++, (0, _react.useContext)(_.RepositoryContext)) || (cov_ex3acj5mf.b[0][1]++, {})),
      repository = _ref3.state,
      actions = _ref3.actions,
      repositoryComponent = _ref3.component;

  var _ref4 = (cov_ex3acj5mf.s[3]++, (cov_ex3acj5mf.b[1][0]++, repository) || (cov_ex3acj5mf.b[1][1]++, {})),
      name = _ref4.name,
      avatar_url = _ref4.avatar_url,
      owner = _ref4.owner,
      full_name = _ref4.full_name;

  var handleOpen = (cov_ex3acj5mf.s[4]++, (0, _react.useCallback)(function () {
    cov_ex3acj5mf.f[1]++;
    cov_ex3acj5mf.s[5]++;
    setModal(true);
  }, []));
  var button;
  cov_ex3acj5mf.s[6]++;

  if ((cov_ex3acj5mf.b[3][0]++, name) && (cov_ex3acj5mf.b[3][1]++, owner)) {
    cov_ex3acj5mf.b[2][0]++;
    var avatarComponent = (cov_ex3acj5mf.s[7]++, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      src: (cov_ex3acj5mf.b[4][0]++, avatar_url) || (cov_ex3acj5mf.b[4][1]++, owner.avatar_url)
    }));
    cov_ex3acj5mf.s[8]++;
    button = /*#__PURE__*/_react.default.createElement(_core.Chip, {
      "data-test": "repository-item-icon",
      avatar: avatarComponent,
      label: name,
      onDelete: (cov_ex3acj5mf.b[5][0]++, actions) && (cov_ex3acj5mf.b[5][1]++, actions.close),
      color: "primary"
    });
  } else {
    cov_ex3acj5mf.b[2][1]++;
    cov_ex3acj5mf.s[9]++;
    button = /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: handleOpen,
      color: "inherit"
    }, /*#__PURE__*/_react.default.createElement(_icons.FolderShared, null));
  }

  ;
  var modalComponent = (cov_ex3acj5mf.s[10]++, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  cov_ex3acj5mf.s[11]++;

  if ((cov_ex3acj5mf.b[7][0]++, modal) && (cov_ex3acj5mf.b[7][1]++, !full_name)) {
    cov_ex3acj5mf.b[6][0]++;
    cov_ex3acj5mf.s[12]++;
    modalComponent = /*#__PURE__*/_react.default.createElement(_core.Modal, {
      "data-test": "repository-menu-modal",
      open: true,
      onClose: function onClose() {
        cov_ex3acj5mf.f[2]++;
        cov_ex3acj5mf.s[13]++;
        return setModal(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      className: classes.modal
    }, repositoryComponent));
  } else {
    cov_ex3acj5mf.b[6][1]++;
  }

  ;
  cov_ex3acj5mf.s[14]++;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test": "repository-menu"
  }, button, modalComponent);
}

;
cov_ex3acj5mf.s[15]++;
RepositoryMenu.propTypes = {};
var _default = RepositoryMenu;
exports.default = _default;